module.exports = __webpack_public_path__ + "img/mcgl_fp_08.d24c3d8a.png";